/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const JasperServerStatus = createEnum('JC_STATUS', {
  Inactive: 'INACTIVE',
  Active: 'ACTIVE',
  InProcess: 'IN_PROGRESS',
  Terminated: 'TERMINATED',
});

export type JasperServerStatus = EnumSet<typeof JasperServerStatus>;

export type JasperServerDto = {
  url: string;
  status: JasperServerStatus;
};
